var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c("Subheader", {
                attrs: {
                  title: "Manage Continuous Data Databases",
                  "no-search": "",
                },
              }),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", md10: "", "offset-md1": "" } },
                          [
                            _c("div", { staticClass: "headline" }, [
                              _vm._v("Choose Continuous Data Query Database:"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-weight-regular" }, [
                              _vm._v(
                                "Data from this database will be used for station and wrdr continuous data queries."
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-radio-group",
                              {
                                model: {
                                  value: _vm.queryDatabase,
                                  callback: function ($$v) {
                                    _vm.queryDatabase = $$v
                                  },
                                  expression: "queryDatabase",
                                },
                              },
                              [
                                _c("v-radio", {
                                  attrs: {
                                    label: "AquariusNG",
                                    value: "AquariusNG",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        block: "",
                        disabled: _vm.cannotSave,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.agreeSave()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "secondary",
                        outline: "",
                        dark: "",
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "accessManage" })
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("PageLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "app-confirmation-modal",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.saveFailed,
            callback: function ($$v) {
              _vm.saveFailed = $$v
            },
            expression: "saveFailed",
          },
        },
        [
          _c("template", { slot: "app-modal-title" }, [
            _vm._v("\n      Save Continuous Data Databases Failed\n    "),
          ]),
          _vm._v(" "),
          _c("template", { slot: "app-modal-text" }, [
            _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "app-modal-actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: {
                    click: function ($event) {
                      _vm.saveFailed = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }